module.exports = __webpack_public_path__ + "static/media/chokha4.78df4d0b.webp";